import React from "react";

const UpIcon = ({style}) => {
    return <svg width="141" height="211" viewBox="0 0 141 211" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
    <path d="M79.0003 210C86.7343 187.011 91.4608 124.395 88.6893 94.1506C85.9177 63.9067 83.2365 46.906 65.8895 6.50822" stroke="white" strokeLinecap="round"/>
    <path d="M63.9384 19.4309C64.1077 15.0296 63.5098 11.1385 62.6296 6.71309C62.3406 5.26012 62.0101 3.83398 62.1518 2.39544C62.2703 1.19228 63.8886 2.56092 64.3049 2.78068C68.5641 5.02904 72.8457 7.24023 77.1237 9.40632" stroke="white" strokeLinecap="round"/>
    </svg>
};

export default UpIcon;